import type { IconProps } from './../../models/icon';

export function ProfileIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M12.0001 13.7143C14.367 13.7143 16.2858 11.7955 16.2858 9.42854C16.2858 7.0616 14.367 5.14282 12.0001 5.14282C9.63314 5.14282 7.71436 7.0616 7.71436 9.42854C7.71436 11.7955 9.63314 13.7143 12.0001 13.7143Z"
        />
        <path
          fill="#fff"
          d="M19.3224 20.3994C17.3642 22.108 14.8029 23.1429 11.9999 23.1429C9.19696 23.1429 6.63572 22.108 4.67749 20.3994C6.18246 17.9325 8.89887 16.2858 11.9999 16.2858C15.101 16.2858 17.8175 17.9325 19.3224 20.3994Z"
        />
        <path
          fill={secondaryColor}
          fillRule="evenodd"
          d="M4.67758 20.3993C6.18255 17.9325 8.89898 16.2857 12 16.2857C15.1011 16.2857 17.8175 17.9325 19.3224 20.3993C21.6636 18.3566 23.1429 15.3511 23.1429 12C23.1429 5.84601 18.1542 0.857178 12 0.857178C5.84601 0.857178 0.857178 5.84601 0.857178 12C0.857178 15.3511 2.33643 18.3566 4.67758 20.3993ZM12 13.7143C14.367 13.7143 16.2857 11.7955 16.2857 9.42861C16.2857 7.06168 14.367 5.14289 12 5.14289C9.6331 5.14289 7.71432 7.06168 7.71432 9.42861C7.71432 11.7955 9.6331 13.7143 12 13.7143Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.0001 13.7143C14.367 13.7143 16.2858 11.7955 16.2858 9.42854C16.2858 7.0616 14.367 5.14282 12.0001 5.14282C9.63314 5.14282 7.71436 7.0616 7.71436 9.42854C7.71436 11.7955 9.63314 13.7143 12.0001 13.7143Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M4.67993 20.4C5.44491 19.1443 6.52006 18.1065 7.80201 17.3865C9.08395 16.6663 10.5296 16.2881 11.9999 16.2881C13.4703 16.2881 14.9159 16.6663 16.1979 17.3865C17.4799 18.1065 18.5549 19.1443 19.32 20.4"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 23.1429C18.1541 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.84601 18.1541 0.857178 12 0.857178C5.84601 0.857178 0.857178 5.84601 0.857178 12C0.857178 18.1541 5.84601 23.1429 12 23.1429Z"
        />
      </g>
    </svg>
  );
}
